var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"xs":12,"sm":12,"md":12,"lg":12,"xl":12}},[_c('invoice')],1),_c('el-col',{attrs:{"xs":12,"sm":12,"md":12,"lg":12,"xl":12}},[_c('grn')],1),_c('tips',{ref:"tipsDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }